import { render, staticRenderFns } from "./FacebookAd.vue?vue&type=template&id=07b78d12&"
import script from "./FacebookAd.vue?vue&type=script&lang=js&"
export * from "./FacebookAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports